import React, { Fragment } from 'react';
import carruselCmpt from './carrusel.cmpt';
import { goTo } from "../tools";
import './estilos.css';
import { connect } from "react-redux";
import { messageService } from "../centro-atencion-gnp/centro-atencion.service";
import { servicios } from "../properties";

const mapDispatch = (dispatch) => {
    return {
        addEvento: (evento) => {
            dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
        }
    };
};

class Estatico extends React.Component {


    componentWillMount = () => {

    }
    ir = (sRuta) => {
        goTo(sRuta);
    }

    irRutaConIframe = (sRuta) => {

        if (sRuta == 'directorio') {
            console.log('ruta D' + sRuta);
            goTo(sRuta);
            messageService.sendMessage(servicios.iframeGNPURL.directorio);
        }
        if (sRuta == 'acceso-familiar') {
            console.log('ruta A' + sRuta);
            goTo(sRuta);
            messageService.sendMessage(servicios.iframeGNPURL.accesoFamiliar);
        }

    }

    render() {

        return (
            <div className="contenedor-carrusel container">

                <div className="tamCarrusel">
                    <div className="carrusel-noticias">
                        <p className="titulo">¡Estamos para servirte!</p>
                        <a onClick={this.ir.bind(this, "banner01")} href={"https://www.gnp.com.mx/post-venta/contacto-ventas"} target="_blank">
                            <img src={require("../img/Banner_PortalSoyCliente-04.png")} />
                        </a>
                        <p className="subtitulo">Con gusto te ayudamos a resolver tus dudas o atender a tus comentarios</p>
                    </div>

                </div>
                <div className="tamCarrusel">

                    <div className="carrusel-noticias">
                        <p className="titulo">¡Descubre la App de tu Seguro GNP!</p>
                        <a onClick={this.ir.bind(this, "banner02")} href={"https://www.gnp.com.mx/soy-cliente/#!/gnp/servicios-videos/7"} target="_blank">
                            <img src={require("../img/Banner_PortalSoyCliente-01.png")} />
                        </a>
                        <p className="subtitulo">Consulta tu Póliza, reporta un siniestro y mucho más</p>
                    </div>

                </div>


                <div className="tamCarrusel">

                    <div className="carrusel-noticias">
                        <p className="titulo">¿Necesitas ubicar un hospital?</p>
                        <a onClick={this.irRutaConIframe.bind(this, "directorio")}>
                            <img src={require("../img/Banner_PortalSoyCliente-06.png")} />
                        </a>
                        <p className="subtitulo">Disponible en tu portal y App Soy Cliente GNP</p>
                    </div>

                </div>
                <div className="tamCarrusel">

                    <div className="carrusel-noticias">
                        <p className="titulo">¿Otro conductor maneja tu auto?</p>
                        <a onClick={this.irRutaConIframe.bind(this, "acceso-familiar")}>
                            <img src={require("../img/Banner_PortalSoyCliente-05.png")} />
                        </a>
                        <p className="subtitulo">Para visualizar tu Póliza y solicitar asistencia vial desde la App Soy Cliente GNP</p>
                    </div>

                </div>
            </div>

        );

        // return <iframe className="centro-atencion-iframe-responsive" src='https://aclaracionesqr-siniestros.gnp.com.mx/' frameborder="0"></iframe>          
    }
}
export default connect(null, mapDispatch)(Estatico);



// WEBPACK FOOTER //
// ./src/carrusel/estatico.cmpt.js